import BossKillsStrip from '../../../globalCoverage/components/bossKillsStrip';
import RaceVisualizer from '../../../globalCoverage/components/raceVisualizer';
import { createActionGetRaceProgress } from '../../../actions/getRaceProgress';
import apiService from '../../../services/apiService';
import _ from 'lodash';
import frontendLog from '../../../libs/frontendLog';
import RaceVisualizerActions from '../../../actions/raceVisualizerActions';

export type TRWFVisualizerPaneProps = {
  enabled: boolean;
  raidSlug: string;
  difficulty: string;
  region: string;
  instanceId?: string;
};

export default function RWFVisualizerPane(props: TRWFVisualizerPaneProps) {
  if (!props.enabled) {
    return null;
  }

  return (
    <>
      <BossKillsStrip
        instanceId={props.instanceId}
        raidSlug={props.raidSlug}
        regionSlug={props.region}
        difficulty={props.difficulty}
        className="slds-m-top--large"
        refresh={false}
      />

      <RaceVisualizer
        instanceId={props.instanceId}
        raid={props.raidSlug}
        region={props.region}
        style={{ maxWidth: '100%' }}
        refresh={false}
      />
    </>
  );
}

(RWFVisualizerPane as any).preloadComponentActions = async (props: TRWFVisualizerPaneProps, params: any) => {
  if (!props.enabled) {
    return Promise.resolve([]);
  }

  return _.flatten(
    await Promise.all([
      new Promise((resolve: any, reject: any) => {
        const loadParams = {
          raid: props.raidSlug,
          region: props.region,
          difficulty: props.difficulty,
          faction: '',
          includeLogData: true
        };

        apiService.getRaceProgress(loadParams, (err: any, result?: any) => {
          if (err) {
            frontendLog.error({ err }, 'getRaceProgress failed');
            reject(err);
          }

          if (!result) {
            frontendLog.error('getRaceProgress failed');
            reject(new Error('getRaceProgress failed'));
          }

          resolve([createActionGetRaceProgress('default', result.raceProgress)]);
        });
      }),
      new Promise((resolve: any, reject: any) => {
        const loadParams: any = {
          raid: props.raidSlug,
          region: props.region,
          difficulty: 'mythic'
        };

        apiService.getRaidRaceTracker(loadParams, (err: any, result?: any) => {
          if (err) {
            frontendLog.error({ err }, 'getRaidRaceTracker failed');
            reject(err);
          }

          if (!result) {
            frontendLog.error('getRaidRaceTracker failed');
            reject(new Error('getRaidRaceTracker failed'));
          }

          resolve([RaceVisualizerActions.setWorldFirstTracker('default', result.worldFirstTracker)]);
        });
      })
    ])
  );
};
